import { Controller } from "@hotwired/stimulus"

// A piece in the feed opens on a tap anywhere in its text, the way a card in
// a well-made reader does - but a name in the text still goes to the name, a
// passage being selected stays selected, and a right-click is left alone.
export default class extends Controller {
  static values = { url: String }

  open(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    if (event.target.closest("a, button, input, textarea, summary, [role='button'], .aside-mark, .aside-open, .aside-card")) return
    if (window.getSelection()?.toString()) return

    window.Turbo.visit(this.urlValue)
  }
}
